"use strict"; 

Shopify.theme.jsFadingGallery = {
  init: function init($section) {
    // Add settings from schema to current object
    Shopify.theme.jsFadingGallery = $.extend(this, Shopify.theme.getSectionData($section));
    
    this.$items = $section.find('[data-gallery-item]')
    this.lastActive = [0,0,0,0]
    this.$items.each(function(index,item){
		this.loopItem(index)
    }.bind(this))
  },
  loopItem:function(index){
    let rand = Math.floor(Math.random() * (15000 - 5000 + 1) + 5000)
    setTimeout(function(){
      this.switchImage(index)
      this.loopItem(index)
    }.bind(this), rand);
  },
  switchImage:function(index){
    const randActive = Math.floor(Math.random() * 4);
    let $current = this.$items.eq(index).children()
    $current.removeClass('is-selected')
    $current.eq(randActive).addClass('is-selected')
    this.lastActive[index] = randActive
  },
  unload: function unload($section) {}
};